import type { TOC } from '@ember/component/template-only';
import MyItemsList from '../../components/my-items-list.gts';
import MobileHeader from '../../components/mobile-header.gts';

interface Signature {
  Args: {};
}

const MyItemsIndexTemplate: TOC<Signature> = <template>
  <MobileHeader @title="My Items" />
  <h1 class="mb-6 hidden text-3xl font-bold lg:block">My Items</h1>
  <MyItemsList />
</template>;

export default MyItemsIndexTemplate;
